// import { configureStore } from '@reduxjs/toolkit'
// import notificationSlice from './slices/notificationSlice'
// import authSlice from './slices/authSlice'
// import translationSlice from './slices/languageSlice'
// import themeSlice from './slices/themeSlice'
// import accessCodeSlice from './slices/accessCodeSlice'
// import clientsSlice from './slices/clientsSlice'
// import fiSlice from './slices/fiSlice'
// import partnerClientIdSlice from './slices/partnerClientIdsSlice'

// export const store = configureStore({
//   reducer: {
//     notification_slice: notificationSlice,
//     auth_slice: authSlice,
//     accessCode_slice: accessCodeSlice,
//     translation_slice: translationSlice,
//     theme_slice: themeSlice,
//     clients_slice: clientsSlice,
//     fi_slice: fiSlice,
//     partnerClientIds_slice: partnerClientIdSlice,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({ serializableCheck: false }),
// })

// export type RootState = ReturnType<typeof store.getState>

// export type AppDispatch = typeof store.dispatch

import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit'
import notificationSlice from './slices/notificationSlice'
import { logout } from './actions/authActions'
import authSlice from './slices/authSlice'
import translationSlice from './slices/languageSlice'
import themeSlice from './slices/themeSlice'
import accessCodeSlice from './slices/accessCodeSlice'
import clientsSlice from './slices/clientsSlice'
import fiSlice from './slices/fiSlice'
import partnerClientIdSlice from './slices/partnerClientIdsSlice'
import { saveStateToLocalStorage } from '../utils'
import businessSlice from './slices/businessSlice'
import analyticsSlice from './slices/analyticsSlice'

const appReducer = combineReducers({
  notification_slice: notificationSlice,
  auth_slice: authSlice,
  accessCode_slice: accessCodeSlice,
  translation_slice: translationSlice,
  theme_slice: themeSlice,
  clients_slice: clientsSlice,
  fi_slice: fiSlice,
  partnerClientIds_slice: partnerClientIdSlice,
  business_slice: businessSlice,
  analytics_slice: analyticsSlice,
})

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
  if (action.type === logout.fulfilled.type) {
    // Clear all localStorage
    saveStateToLocalStorage('authState', {})
    saveStateToLocalStorage('accessCodeState', {})
    saveStateToLocalStorage('clientsState', {})
    // Add any other localStorage keys you need to clear
    
    // Preserve theme and language, reset everything else
    const { theme_slice, translation_slice } = state ?? {}
    return appReducer({ theme_slice, translation_slice } as any, action)
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch